import { render, staticRenderFns } from "./ViewBlockVendor.vue?vue&type=template&id=3298880d&"
import script from "./ViewBlockVendor.vue?vue&type=script&lang=js&"
export * from "./ViewBlockVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports